"use client"

import * as React from "react"
import { cn } from "@/lib/utils"

interface SliderProps {
    value: number[]
    onValueChange?: (value: number[]) => void
    min?: number
    max?: number
    step?: number
    className?: string
    disabled?: boolean
}

const Slider = React.forwardRef<HTMLInputElement, SliderProps>(
    ({ value, onValueChange, min = 0, max = 100, step = 1, className, disabled, ...props }, ref) => {
        const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
            const newValue = Number(e.target.value)
            onValueChange?.([newValue])
        }

        const percentage = ((value[0] - min) / (max - min)) * 100

        return (
            <div className={cn("relative flex w-full touch-none select-none items-center", className)}>
                <div className="relative h-2 w-full grow overflow-hidden rounded-full bg-gray-200">
                    {/* Track fill */}
                    <div
                        className="absolute h-full bg-gradient-to-r from-teal-500 to-green-500 transition-all"
                        style={{ width: `${percentage}%` }}
                    />
                </div>
                <input
                    ref={ref}
                    type="range"
                    min={min}
                    max={max}
                    step={step}
                    value={value[0]}
                    onChange={handleChange}
                    disabled={disabled}
                    className="absolute inset-0 h-2 w-full cursor-pointer opacity-0 disabled:cursor-not-allowed"
                    {...props}
                />
                {/* Thumb */}
                <div
                    className="absolute h-5 w-5 rounded-full border-2 border-white bg-gradient-to-r from-teal-500 to-green-500 shadow-lg transition-all hover:scale-110 disabled:pointer-events-none disabled:opacity-50"
                    style={{
                        left: `calc(${percentage}% - 10px)`,
                        transform: 'translateY(-50%)',
                        top: '50%'
                    }}
                />
            </div>
        )
    }
)

Slider.displayName = "Slider"

export { Slider }
